/* IntelApps — initial load overlay (~3s), logo in animated SVG */
import React, { useEffect, useId, useState } from 'react';

const HOLD_MS = 3000;
const FADE_MS = 600;

const logoPublicPath = `${process.env.PUBLIC_URL || ''}/assets/Logo.png`;

function LoaderLogoSvg() {
  const reactId = useId().replace(/:/g, '');
  const clipId = `site-loader-clip-${reactId}`;
  const ringGradId = `site-loader-ring-${reactId}`;

  return (
    <div className="site-loader-logo-wrap" aria-hidden="true">
      <svg
        className="site-loader-logo-svg"
        viewBox="0 0 120 120"
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
      >
        <defs>
          <clipPath id={clipId}>
            <circle cx="60" cy="60" r="40" />
          </clipPath>
          <linearGradient id={ringGradId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="var(--accent)" stopOpacity={0.22} />
            <stop offset="50%" stopColor="var(--accent)" stopOpacity={1} />
            <stop offset="100%" stopColor="var(--accent)" stopOpacity={0.22} />
          </linearGradient>
        </defs>
        <g className="site-loader-ring-g">
          <circle
            cx="60"
            cy="60"
            r="54"
            fill="none"
            stroke={`url(#${ringGradId})`}
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray="52 288"
          />
        </g>
        <image
          className="site-loader-logo-img"
          href={logoPublicPath}
          x="20"
          y="20"
          width="80"
          height="80"
          clipPath={`url(#${clipId})`}
          preserveAspectRatio="xMidYMid meet"
        />
      </svg>
    </div>
  );
}

export default function SiteLoader() {
  const [phase, setPhase] = useState('in');

  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const fadeTimer = setTimeout(() => setPhase('out'), Math.max(0, HOLD_MS - FADE_MS));
    const doneTimer = setTimeout(() => {
      document.body.style.overflow = prevOverflow || '';
      setPhase('done');
    }, HOLD_MS);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
      document.body.style.overflow = prevOverflow || '';
    };
  }, []);

  if (phase === 'done') return null;

  return (
    <div
      className={`site-loader${phase === 'out' ? ' site-loader--out' : ''}`}
      aria-busy="true"
      aria-live="polite"
    >
      <div className="site-loader-inner">
        <LoaderLogoSvg />
        <span className="sr-only">Loading</span>
      </div>
    </div>
  );
}
